import { render, staticRenderFns } from "./upload-csv.vue?vue&type=template&id=36b1fb6c&scoped=true"
import script from "./upload-csv.vue?vue&type=script&lang=js"
export * from "./upload-csv.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36b1fb6c",
  null
  
)

export default component.exports